import { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { isViewMode, ViewMode } from 'app/agriculture/AgTimeline/types';
import {
    useTimelineViewMode,
    useTimelineDispatch,
} from 'app/agriculture/AgTimeline/context/TimelineContext';
import { viewModeConfig } from 'app/agriculture/AgTimeline/viewModeConfig';
import './TimescaleControl.scss';
import { ToggleButtons } from 'app/agriculture/components/ToggleButtons/ToggleButtons';

interface TimescaleControlProps {
    className?: string;
}

export function TimescaleControl({ className }: TimescaleControlProps) {
    const currentViewMode = useTimelineViewMode();
    const { setViewMode } = useTimelineDispatch();

    const options: { name: string; viewMode: keyof typeof ViewMode }[] = useMemo(
        () =>
            Object.entries(viewModeConfig).map(([viewMode, { label }]) => ({
                name: label,
                viewMode: viewMode as keyof typeof ViewMode,
            })),
        [],
    );

    const handleChange = useCallback(
        ({ viewMode }: (typeof options)[number]) => {
            if (!isViewMode(viewMode)) return;
            setViewMode(viewMode);
        },
        [setViewMode],
    );

    return (
        <div className={classNames('TimescaleControl', className)}>
            <ToggleButtons
                className={classNames('TimescaleControl__buttons')}
                options={options}
                defaultSelection={currentViewMode.label}
                onChange={handleChange}
            />
        </div>
    );
}
